import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesTraspasos() {
  const { user } = useContext(AuthContext);

  const SECCIONES = [
    { section: "Movimientos", items: [
      { label: "Solicitud Traspaso", icon: "fas fa-file-export", color: "#f59e0b", href: "/ListadoTraspasosSolicitud", desc: "Solicitar mercancia", enabled: !!user.menu_traspasos_salida },
      { label: "Traspasos Salida", icon: "fas fa-sign-out-alt", color: "#ef4444", href: "/ListadoTraspasosSalida", desc: "Salidas", enabled: !!user.menu_traspasos_salida },
      { label: "Traspasos Entrada", icon: "fas fa-sign-in-alt", color: "#10b981", href: "/ListadoTraspasosEntrada", desc: "Entradas", enabled: !!user.menu_traspasos_entrada },
    ]},
    { section: "Cuentas y Reportes", items: [
      { label: "Abonos", icon: "fas fa-dollar-sign", color: "#3b82f6", href: "/ListadoAbonosTraspasos", desc: "Abonos de traspaso", enabled: !!user.abonos },
      { label: "Estado de Cuenta", icon: "fas fa-file-invoice-dollar", color: "#6366f1", href: "/EstadoCuentaTraspasos", desc: "Saldos entre areas", enabled: !!user.edoCtaClientes },
      { label: "Reporte Traspasos", icon: "fas fa-clipboard-list", color: "#06b6d4", href: "/ReporteTraspasos", desc: "Reporte por fechas", enabled: !!user.menu_traspasos_salida },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Traspasos"
      descripcion="Movimiento de mercancia entre areas"
      icono="fas fa-exchange-alt"
      color="#f59e0b"
      secciones={SECCIONES}
    />
  );
}

export default BotonesTraspasos;
